import type { ReactNode } from 'react';
import { useState } from 'react';
import { HeaderContext, HeaderSlotContext } from './context';
import Header from './Header';

export default function HeaderProvider({ children }: { children: ReactNode }) {
  const [headerSlot, setHeaderSlot] = useState<ReactNode>(null);
  return (
    <HeaderContext value={{ setHeaderSlot }}>
      <HeaderSlotContext value={{ headerSlot }}>
        <Header />
        {children}
      </HeaderSlotContext>
    </HeaderContext>
  );
}
